import axios from 'axios';

// ── 호출 스택 찍기용 인터셉터 ──
axios.interceptors.request.use((cfg) => {
  if (cfg.url?.startsWith('/api/town')) {
    console.trace('[TRACE] /api/town');
  }
  if (cfg.url?.startsWith('/api/energydata')) {
    console.trace('[TRACE] /api/energydata');
  }
  // 필요하면 추가…
  return cfg;
});

// 아무것도 export 하지 않음 (side‑effect only)

